import "./Help.css";
import { SupportTicketsButton } from "widgets/support-tickets";
import { WheelRafflesButton } from "widgets/wheel-raffles";

interface HelpProps {
  // На десктопе промо открываются из боковой панели; она скрыта
  // на мобильных, поэтому там кнопка остаётся во вкладке Help.
  withPromos?: boolean;
}

const Help = ({ withPromos = false }: HelpProps) => {
  return (
    <div className="help">
      <p className="help-label">Telegram Channel:</p>
      <a
        className="help-link"
        href="https://t.me/ProfitOption_support"
        target="_blank"
      >
        @ProfitOption_support
      </a>
      <p className="help-label">Support requests:</p>
      <SupportTicketsButton />
      {withPromos && (
        <>
          <p className="help-label">Promotions:</p>
          <WheelRafflesButton />
        </>
      )}
    </div>
  );
};

export default Help;
